(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const initializePickupCheckoutGuard = (root) => {
    if (root.dataset.pickupGuardInitialized === 'true') return;

    root.dataset.pickupGuardInitialized = 'true';

    const update = () => {
      const button = root.querySelector('#checkout');
      const widget = root.querySelector('.oct-map-cart-widget');

      if (!button || !widget) return;

      const pointName = root.querySelector('.selected-pp-details .pp-name');
      const hasSelection = Boolean(pointName?.textContent.trim());
      const isDisabled = !hasSelection;
      const ariaDisabled = String(isDisabled);
      const label = hasSelection
        ? root.dataset.readyLabel
        : root.dataset.waitingLabel;

      if (button.disabled !== isDisabled) {
        button.disabled = isDisabled;
      }

      if (button.getAttribute('aria-disabled') !== ariaDisabled) {
        button.setAttribute('aria-disabled', ariaDisabled);
      }

      if (button.textContent.trim() !== label) {
        button.textContent = label;
      }

      const breakdown = root.querySelector('.oxycult-cart-breakdown');
      const deliveryRow = root.querySelector('.oxycult-cart-breakdown__delivery');
      const grandRow = root.querySelector('.oxycult-cart-breakdown__grand');
      const shippingValue = root.querySelector('[data-pickup-shipping]');
      const grandValue = root.querySelector('[data-cart-grand-total]');
      const pointPrice = root.querySelector('.selected-pp-details .pp-price');

      if (!breakdown || !deliveryRow || !grandRow || !shippingValue || !grandValue) return;

      const shippingText = pointPrice?.textContent.trim() || '';
      const numericShipping = shippingText
        .replace(/\u00a0/g, '')
        .replace(/\s/g, '')
        .match(/-?[\d.,]+/)?.[0]
        ?.replace(/\.(?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');
      const shippingAmount = Number.parseFloat(numericShipping);
      const subtotalCents = Number.parseInt(breakdown.dataset.cartSubtotalCents || '', 10);
      const hasShippingPrice =
        hasSelection &&
        Number.isFinite(shippingAmount) &&
        Number.isFinite(subtotalCents);

      if (deliveryRow.hidden === hasShippingPrice) {
        deliveryRow.hidden = !hasShippingPrice;
      }

      if (grandRow.hidden === hasShippingPrice) {
        grandRow.hidden = !hasShippingPrice;
      }

      if (!hasShippingPrice) return;

      if (shippingValue.textContent.trim() !== shippingText) {
        shippingValue.textContent = shippingText;
      }

      const shippingCents = Math.round(shippingAmount * 100);
      const grandTotal = new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'PLN',
      }).format((subtotalCents + shippingCents) / 100);

      if (grandValue.textContent.trim() !== grandTotal) {
        grandValue.textContent = grandTotal;
      }
    };

    const observer = new MutationObserver(update);
    observer.observe(root, { childList: true, subtree: true });
    update();
  };

  const initializePickupCheckoutGuards = (scope) => {
    scope
      .querySelectorAll('cart-items-component[data-ready-label]')
      .forEach(initializePickupCheckoutGuard);
  };

  initializePickupCheckoutGuards(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializePickupCheckoutGuards(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
